module.exports = __webpack_public_path__ + "img/profile_five_001.ad031e65.png";